import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AddOtherNotes = () => {
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicsId, setTopicsId] = useState("");

  const [noteTitle, setNoteTitle] = useState("");
  const [file, setFile] = useState(null);
  const [language, setLanguage] = useState("");

  // ✅ ADDED: videoUrl state
  const [videoUrl, setVideoUrl] = useState("");

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  //----------------------------------------------------------------------

  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []); // keep as-is

  const getAllTopics = () => {
    if (!categoryId) {
      setTopics([]);
      setTopicsId("");
      return;
    }

    axios
      .get(`${API_BASE_URL}/topics?categoryId=${categoryId}`)
      .then((response) => {
        setTopics(response.data?.topics || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTopics();
  }, [categoryId]); // keep as-is

  //----------------------------------------------------------------------

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Create FormData to handle file and other data
    const formData = new FormData();
    formData.append("noteTitle", noteTitle);
    formData.append("language", language);

    // ✅ ADDED: include videoUrl
    formData.append("videoUrl", videoUrl);

    formData.append("noteFile", file); // Append file
    formData.append("topicId", topicsId);

    // POST request to /notes
    axios
      .post(`${API_BASE_URL}/admin/notes`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        alert("Others Note added successfully!");
        navigate("/upload-notes/all-other-notes"); // Navigate after success
      })
      .catch((error) => {
        console.error("Error adding note:", error);
        alert("There was an error adding the note.");
      });
  };

  // Navigation handlers
  const handleAddNewNote = () => {
    navigate("/upload-notes/add-other-notes");
  };

  const handleViewAllNotes = () => {
    navigate("/upload-notes/all-other-notes");
  };

  const handleGoBack = () => {
    navigate("/upload-notes/upload-all-notes");
  };

  return (
    <>
      <div id="exam-school-notes-inner-wrapper">
        <div className="main-header">
          <BiArrowBack
            onClick={handleGoBack}
            className="left-arrow-icon"
            style={{
              cursor: "pointer",
              display: "flex",
              fontSize: "25px",
              color: "#000",
            }}
          />
          <div className="exam-header-div">
            <h5>Others Notes</h5>
            <div className="exam-btn-group">
              <button className="addNewNoteBtn" onClick={handleAddNewNote}>
                + Upload Notes
              </button>
              <button className="viewAllNotesBtn" onClick={handleViewAllNotes}>
                All Notes
              </button>
            </div>
          </div>

          <div className="form-container" id="form">
            <h4 className="note-detail">Note Details</h4>
            <form onSubmit={handleSubmit} className="note-detail-form">
              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Category</label>
                <select
                  className="new-chapter-dropdown"
                  value={categoryId}
                  onChange={(e) => setCategoryId(e.target.value)}
                  required
                >
                  <option value="">-Select Category-</option>
                  {category &&
                    category.map((item, idx) => (
                      <option key={idx} value={item?._id}>
                        {item?.category}
                      </option>
                    ))}
                </select>
              </div>

              <div className="new-chapter-form-group">
                <label className="new-chapter-label">Category Topic</label>
                <select
                  className="new-chapter-dropdown"
                  value={topicsId}
                  onChange={(e) => setTopicsId(e.target.value)}
                  required
                >
                  <option value="">-Select Topic-</option>
                  {topics &&
                    topics.map((item, idx) => (
                      <option key={idx} value={item._id}>
                        {item?.topic}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group">
                <label className="label">Note Title</label>
                <input
                  type="text"
                  value={noteTitle}
                  onChange={(e) => setNoteTitle(e.target.value)}
                  placeholder="Enter Note Title"
                  required
                />
              </div>

              {/* ✅ ADDED: Video URL input */}
              <div className="input-group">
                <label className="label">Video URL</label>
                <input
                  type="text"
                  value={videoUrl}
                  onChange={(e) => setVideoUrl(e.target.value)}
                  placeholder="https://youtube.com/watch?v=..."
                />
                {!!videoUrl && (
                  <small style={{ display: "block", marginTop: 6 }}>
                    <a href={videoUrl} target="_blank" rel="noreferrer">
                      Preview Video
                    </a>
                  </small>
                )}
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Language</label>
                  <input
                    style={{ marginLeft: "10px" }}
                    type="radio"
                    value="hindi"
                    checked={language === "hindi"}
                    onChange={(e) => setLanguage(e.target.value)}
                    required
                  />
                  Hindi
                  <input
                    style={{ marginLeft: "10px" }}
                    type="radio"
                    value="english"
                    checked={language === "english"}
                    onChange={(e) => setLanguage(e.target.value)}
                    required
                  />
                  English
                </div>
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Upload File (pdf format)</label>
                </div>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])} // Capture the file object
                  accept=".pdf" // Restrict file type to PDF
                  required
                />
              </div>

              <div className="form1-btns">
                <button className="btn-save">Save</button>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={handleGoBack}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOtherNotes;